import { Component } from 'react';

import { compose } from 'redux';

import { loadRoadmapPosts } from 'common/actions/roadmapPosts';
import asyncConnect from 'common/core/asyncConnect';
import cloneElementWithProps from 'common/core/cloneElementWithProps';
import { getPostQueryKey, getQueryFilterParams } from 'common/util/filterPosts';

import type { Company } from 'common/api/endpoints/companies';
import type { RoadmapPost } from 'common/api/endpoints/roadmapPosts';
import type { BoardStateItem } from 'common/reducers/boards';
import type { RoadmapsState } from 'common/reducers/publicPrioritizationRoadmap';

const EmptyRoadmapPosts = { posts: [] };
const asyncFetch = {
  key: 'asyncPublicPrioritizationRoadmapPosts',
  promise: ({ store: { dispatch, getState }, location, params }: PromiseOptions) => {
    const state = getState();

    const { publicPrioritizationRoadmap } = state ?? {};
    const roadmaps = publicPrioritizationRoadmap?.roadmaps ?? {};
    const roadmap = roadmaps[params.roadmapViewID] ?? null;

    const company = state.company;

    if (!company) {
      return;
    }

    return dispatch(loadRoadmapPosts(getQueryFilterParams(null, company, location, {}, roadmap)));
  },
};

type Props = {
  publicPrioritizationRoadmap: RoadmapsState;
  company: Company;
  boards: { items: { [key: string]: BoardStateItem } };
  roadmapPostsLoading: boolean;
  roadmapPosts: Record<string, RoadmapPost>;
  params: { boardURLName: string; roadmapViewID: string };
  location: { pathname: string };
};

class PublicPrioritizationRoadmapPostsContainer extends Component<Props> {
  static asyncConnect = asyncFetch;

  render() {
    const {
      company,
      children,
      publicPrioritizationRoadmap,
      roadmapPosts,
      location,
      roadmapPostsLoading,
      boards,
      params,
    } = this.props;
    const roadmaps = publicPrioritizationRoadmap.roadmaps ?? {};
    const roadmap = roadmaps[params.roadmapViewID] ?? null;
    const board = boards.items[params.boardURLName];
    const postQueryKey = getPostQueryKey(
      getQueryFilterParams(board, company, location, {}, roadmap)
    );
    return cloneElementWithProps(children, {
      ...this.props,
      roadmapPosts: roadmapPosts[postQueryKey] ?? EmptyRoadmapPosts,
      roadmapPostsLoading,
    });
  }
}

export default compose(
  asyncConnect([asyncFetch], (state) => ({
    company: state.company,
    boards: state.boards,
    roadmapPosts: state.roadmapPosts,
    roadmapPostsLoading: state.reduxAsyncConnect.loadState?.asyncRoadmapPosts?.loading ?? false,
  }))
)(PublicPrioritizationRoadmapPostsContainer);
